export default {
  title: 'Google business',
  sections: {
    google_business_info: 'Google Unternehmensinformationen',
    google_reviews: 'Google-Bewertungen',
    settings: 'Einstellungen',
    danger_zone: 'Gefahrenzone',
  },
  form: {
    reviews_autopilot_enabled: {
      label: 'KI-Antworten automatisch aktivieren',
    },
    reviews_autopilot_daily_limit: {
      label: 'Tägliches Limit für KI-Antworten (min. 1, max. 15)',
    },
    reviews_autopilot_delay_hours: {
      label: 'Anzahl der Stunden, die nach der Bewertung vergehen sollen',
    },
    unanswered_checkbox: {
      show_all_reviews: 'Alle Bewertungen anzeigen',
      show_only_unanswered: 'Nur unbeantwortete anzeigen',
    },
    rating_filter: {
      label: 'Bewertungsfilter',
      stars_one: '{{count}} Stern',
      stars_other: '{{count}} Sterne',
    },
    sorting: {
      newest_to_oldest: 'Nach neuestem zu ältestem sortieren',
      oldest_to_newest: 'Nach ältestem zu neuestem sortieren',
      rating_highest_to_lowest: 'Nach höchster zu niedrigster Bewertung sortieren',
      rating_lowest_to_highest: 'Nach niedrigster zu höchster Bewertung sortieren',
    },
  },
  table: {
    pagination: {
      total_one: 'Insgesamt {{count}} Bewertung',
      total_other: 'Insgesamt {{count}} Bewertungen',
    },
  },
  modal_publish: {
    title: 'Bist du sicher, dass du bei Google veröffentlichen möchtest?',
    buttons: {
      yes: 'Ja',
      cancel: 'Abbrechen',
    },
  },
  popconfirm: {
    title: 'Bist du sicher?',
    description: 'Alle lokalen Änderungen werden überschrieben.',
  },
  disconnect_profile: {
    title: 'Profil abtrennen',
    button: 'Weiter',
    popconfirm: {
      title: 'Bist du sicher?',
      description:
        'Dadurch wird dieses Google-Profil vollständig von FoodAmigos getrennt, einschließlich der automatischen Ersetzung von Links und der automatischen Beantwortung von Bewertungen!',
    },
  },
  buttons: {
    login_with_google: 'Anmeldung mit Google',
    sync_from_google: 'Hole die neueste Version',
    publish_to_google: 'Bei Google veröffentlichen',
    previous: 'Vorherige',
    next: 'Next',
    save_settings: 'Einstellungen speichern',
  },
  toasts: {
    failed_to_save_changes: 'Änderungen konnten nicht gespeichert werden',
    failed_to_fetch_reviews: 'Abrufen von Bewertungen fehlgeschlagen',
    failed_to_fetch_settings: 'Einstellungen konnten nicht abgerufen werden',
    failed_to_load_google_business: 'Google Business konnte nicht geladen werden',
    failed_to_publish_to_google_business: 'Veröffentlichung auf Google Business fehlgeschlagen',
    publish_access_denied:
      'Google hat die Änderung abgelehnt: Das verbundene Google-Konto kann dieses Unternehmensprofil nicht mehr bearbeiten. Bitte den Zugriff im Google Unternehmensprofil prüfen oder mit dem Google-Konto neu verbinden, das das Restaurant verwaltet.',
    failed_to_fetch_info: 'Fehler beim Abrufen der neuesten Google-Business-Version',
    success_publish_to_google_business: 'Erfolgreich auf Google Business veröffentlicht',
    success_sync_from_google: 'Erfolgreich von Google Business synchronisiert',
    success_save_settings: 'Einstellungen erfolgreich gespeichert',
    failed_to_disconnect_profile:
      'Die Verbindung zu Google Business konnte nicht getrennt werden, bitte kontaktieren Sie das technische Team!',
    popup_blocked: 'Pop-ups für diese Seite erlauben, um Google Business zu verbinden.',
    failed_to_connect: 'Google Business konnte nicht verbunden werden. Bitte erneut versuchen.',
    no_business_profile:
      'Dieses Google-Konto verwaltet kein Unternehmensprofil. Bitte mit dem Google-Konto anmelden, das das Restaurant verwaltet.',
  },
  callback: {
    connecting: 'Google Business wird verbunden…',
    connected: 'Google Business ist verbunden. Dieses Fenster kann geschlossen werden.',
    cancelled: 'Die Anmeldung wurde abgebrochen. Dieses Fenster kann geschlossen werden.',
    failed: 'Google Business konnte nicht verbunden werden. Bitte dieses Fenster schließen und erneut versuchen.',
  },
  alerts: {
    no_profile: {
      title: 'Kein Google-Standort verbunden',
      description: 'Bitte verbinde das Restaurant mit einem Google-Standort.',
      button: {
        connect: 'Verbinden',
      },
    },
    unverified_location: {
      title: 'Das Unternehmen Google ist nicht verifiziert.',
      description: 'Verifizieren Sie Ihr Google-Unternehmen, um fortzufahren.',
    },
  },
};
